export const correlationHeaderDomains = [
  '*.listglobally.com',
  '*.properstar.com',
  '*.azurewebsites.net',
  '*.acproperty.com.au',
]
